import React from 'react';
import { Button } from 'mypages-library';
import { useTranslation } from 'react-i18next';
import { navigateToLogin } from 'common/navigationUtil';
import styles from 'common/PageTemplate/PageTemplate.module.scss';
import PageTemplate from 'common/PageTemplate/PageTemplate';

const InvalidSecret = () => {
  const { t } = useTranslation();
  return (
    <PageTemplate>
      <h1 className={styles.title}>{t('MPL_CHANGE_PW_LINK_EXPIRED_TITLE')}</h1>
      <p className={styles.text}>{t('MPL_CHANGE_PASSWORD_ERROR_SECRET_INVALID_DESC')}</p>
      <Button
        primary
        text={t('MPL_CHANGE_PW_LINK_EXPIRED_BUTTON')}
        onClick={navigateToLogin}
        className={styles.confirmButton}
        dataTestId="invalidSecretLoginBtn"
      />
    </PageTemplate>
  );
};

export default InvalidSecret;
